module.exports = __webpack_public_path__ + "img/2.655bfb24.jpg";